var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0769 0C4.98462 0 0 4.98462 0 11.0769C0 17.1692 4.98462 22.1538 11.0769 22.1538C17.1692 22.1538 22.1538 17.1692 22.1538 11.0769C22.1538 4.98462 17.1692 0 11.0769 0ZM2.76926 11.0769C2.76926 6.50765 6.50773 2.76919 11.077 2.76919C12.877 2.76919 14.5385 3.32304 15.877 4.29227L4.29234 15.8769C3.32311 14.5384 2.76926 12.8769 2.76926 11.0769ZM11.0767 19.3847C9.27674 19.3847 7.6152 18.8308 6.27674 17.8616L17.8614 6.27696C18.8306 7.61543 19.3844 9.27696 19.3844 11.077C19.3844 15.6462 15.646 19.3847 11.0767 19.3847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.92d4918abf082852eb7dba3c925d8cf4.svg";
export { ForwardRef as ReactComponent };